window.addEventListener('load', () => {
    let masonryItem = document.querySelector('.c-powermail-rows--masonry');
    let masonryInstance = new Masonry(masonryItem, {
        percentPosition: true,
        horizontalOrder: true,
        itemSelector: '.powermail_fieldwrap'
    });
});